var uncurryThisRaw = require('../internals/function-uncurry-this-raw');
var toString = uncurryThisRaw({}.toString);
var stringSlice = uncurryThisRaw(''.slice);
module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};